import HttpClient from "../utils/http-client";

export class ClassroomService extends HttpClient {
  async getClassrooms(orgCode, includeChildOrgClassrooms = false) {
    const apiUrl = `/classroom/organization/${orgCode}/classrooms?include_child_org_classrooms=${includeChildOrgClassrooms}`;
    return await this.http.get(apiUrl);
  }
}
